import styled from 'styled-components';
import { formatThousands } from '../../../utils/format/formatNumber';

export default function CustomLabel({ previousTotal, currentTotal }) {
    return (
        <CustomLabelContainer>
            <CustomLabelSpan> {formatThousands(previousTotal)}</CustomLabelSpan>
            <CustomLabelSpan> {formatThousands(currentTotal)}</CustomLabelSpan>
        </CustomLabelContainer>
    );
}
export const CustomLabelContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
export const CustomLabelSpan = styled.span`
    flex: 1;
    width: 100px;
    height: fit-content;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.29;
    color: #9e9e9e;
    text-align: center;
`;
